export default class Feature {
  constructor(data) {
    if (data && data.fields) {
      const { name, description } = data.fields;
      this.name = name;
      this.description = description;
    }
  }
}
